(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this._backdrop = null;
      this._menuObserver = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this._backdrop = document.getElementById('header-nav-backdrop');

      /* Scroll handler */
      this._onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });

      /* Backdrop click → close all */
      if (this._backdrop) {
        this._backdrop.addEventListener('click', () => this.closeAll());
      }

      /* Escape key → close all */
      this._onKey = (e) => { if (e.key === 'Escape') this.closeAll(); };
      document.addEventListener('keydown', this._onKey);

      /* Watch <details> open/close to control backdrop */
      this._setupObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('keydown', this._onKey);
      if (this._menuObserver) this._menuObserver.disconnect();
    }

    _setupObserver() {
      const headerEl = document.querySelector('.header');
      if (!headerEl) return;

      this._menuObserver = new MutationObserver(() => {
        const hasOpen = !!headerEl.querySelector('details[open]');
        if (this._backdrop) {
          /* Set top to just below header so it doesn't cover it */
          const h = (this.header || headerEl).offsetHeight || 80;
          this._backdrop.style.top = h + 'px';
          this._backdrop.classList.toggle('is-active', hasOpen);
        }
        /* Prevent body scroll when mega menu is open */
        document.body.style.overflow = hasOpen ? 'hidden' : '';
      });

      this._menuObserver.observe(headerEl, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open']
      });
    }

    closeAll() {
      document.querySelectorAll('.header details[open]').forEach(d => {
        d.removeAttribute('open');
      });
      if (this._backdrop) this._backdrop.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    onScroll() {
      if (!this.header) return;
      if (window.scrollY > 50) {
        this.header.classList.add('header-wrapper--scrolled');
      } else {
        this.header.classList.remove('header-wrapper--scrolled');
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
